import { useRef, useEffect } from 'react'
import JsBarcode from 'jsbarcode'

/**
 * Renders a barcode into an inline <svg>.
 *
 * Replaces the react-jsbarcode package, which was a thin wrapper around this
 * same JsBarcode call but pinned a peer dependency on React 17 — enough to make
 * `npm ci` fail outright on React 18, and therefore to break deploys on any
 * clean machine. jsbarcode itself is already a direct dependency.
 *
 * The wrapper's behaviour is reproduced deliberately, not approximated:
 * an <svg> holding a ref, and an effect that calls JsBarcode(element, value,
 * options) whenever the value or options change. Tags.test.js pins the exact
 * SVG this produces, so any drift from the previous library shows up as a
 * failing snapshot rather than a misprinted label.
 *
 * @param {object} props
 * @param {string} props.value    - the data to encode
 * @param {object} [props.options] - JsBarcode options (width, height, font…)
 * @param {string} [props.className]
 * @param {object} [props.style]
 */
export default function Barcode({ value, options, className, style }) {
    const ref = useRef(null)

    useEffect(() => {
        if (!ref.current) return
        JsBarcode(ref.current, value, options)
    }, [value, options])

    return <svg ref={ref} className={className} style={style} />
}
